import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../../../theme';

interface QuestionCardProps {
  children: React.ReactNode;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({ children }) => {

  return (
    <Box
      sx={{
        backgroundColor: colors.pureWhite,
        borderRadius: '12px',
        padding: '24px',
        border: `1px solid ${colors.slate[200]}`,
      }}
    >
      {children}
    </Box>
  );
};
